import { last, map } from 'rxjs';
import { NgControl, ValidationErrors } from '@angular/forms';
import { NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Optional, Output, Self, ViewEncapsulation } from '@angular/core';

// enums
import { FILE_TYPE } from 'src/app/core/enums/global/files-types';
import { HTTP_EVENT_TYPE } from 'src/app/core/enums/http-request/httpEventType';

// pipes
import { safeUrlPipe } from 'src/app/core/pipes/files/safe-url.pipe';
import { createUrlPipe } from 'src/app/core/pipes/files/create-url.pipe';

// services
import { ApiResponseService } from 'src/app/core/services/handel-api-response/api-response.service';

// helpers
import { chainKeyForValue } from 'src/app/core/funcations-helper/helpers';


@Component({
  standalone: true,
  selector: 'app-file-upload-field',
  templateUrl: './file-upload-field.component.html',
  styleUrls: ['./file-upload-field.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [ NgIf, NgFor, NgTemplateOutlet, createUrlPipe, safeUrlPipe ]  
})
export class FileUploadFieldComponent implements OnInit {

  /**
   * @description input field name
   */
  @Input({ alias: 'name', required: true }) public Name: string = null;

  /**
   * @description please don't ask me why i write this code, the backend need file wrapping in array,
   * so id don't know why
   */
  @Input({ alias: 'singleFileInArray' }) public SingleFileInArray: boolean = false;  

  /**
   * @description limit files
   */
  @Input({ alias: 'limit' }) public Limit: number = 1;

  /**
   * @description accept multiple files
   */
  @Input({ alias: 'multiple' }) public Multiple: boolean = false;  

  /**
   * @description accept files types
   */
  @Input({ alias: 'accept' }) public Accept: string = null;

  /**
   * @description only files can upload
   */
  @Input({ alias: 'filesTypes' }) public FileTypes: FILE_TYPE[] = [];

  /**
   * @description to mark input as filed required
   */
  @Input({ alias: 'markAsRequired' }) public MarkAsRequired: boolean = false

  /**
   * @description to show in ui, default error msg from validation auto
   */
  @Input({ alias: 'validatorsErrorMsg' }) public validatorsErrorMsg: boolean = true;

  /**
   * @description input field title
   */
  @Input({ alias: 'title' }) public Title: string = null;

  /**
   * @description default icon for ui
   */
  @Input({ alias: 'thumbnailIcons' }) public ThumbnailIcons: string = null;   
  
  /**
   * @description for Preview file in ui after upload
   */
  @Input({ alias: 'isPreview' }) public IsPreview: boolean = false;     

  /**
   * @description to handler upload files to server first then get response
   */
  @Input({ alias: 'server' }) public Server: boolean = false;  

  /**
   * Output
   */
  @Output() Change = new EventEmitter();
  
  /**
   * fields
   */

  /**
   * 
   */
  public touched = false;

  /**
   * 
   */
  public disabled = false;

  /**
   * 
   */
  public pending: boolean = false

  /**
   * 
   */
  private _errors: ValidationErrors | null = null

  /**
   * 
   */
  public _progress: number | HTTP_EVENT_TYPE | null = null

  /**
   * 
   */
  public innerValue: string | string[] | File | File[] = null;

  /**
   * 
   */
  private _files: string | string[] | File | File[] = null;  

  /**
   * 
   * @param _api 
   * @param ngControl 
   */
  constructor(
    private readonly _api: ApiResponseService,
    @Self() @Optional() public ngControl: NgControl
  ) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this
    }

  }

  /**
   * Getters & Setters
   */


  /**
   * 
   */
  public get control() {
    return this.ngControl?.control
  }
    
  // function will catch all errors in input
  public get Errors(): ValidationErrors | null {
    
    return this.control != null ? this.control.errors : this._errors;

  }

  /**
   * 
   */
  private set Errors(err: ValidationErrors | null) {

    /**
     * 
     */
    if (this.control != null) this.control.setErrors(err);
    else this._errors = err;

  }


  /**
   * check validation state
   */
  public get Valid(): boolean {
    /**
     * 
     */
    return this.control != null ? (this.control.valid && this.innerValue !== null) : (this.innerValue !== null)

  }

  /**
   * 
   */
  public get ErrorMsg() {

    return this.validatorsErrorMsg ? chainKeyForValue(this.Errors) : null;

  }
  
  /**
   * 
   */
  public get currentValueHandler(): { title?: string, value?: File | string } {

    if (typeof this.innerValue == 'string') {
      if (this.SingleFileInArray) return { title: this._files[0]?.name, value: this._files[0] };
      else return { value: this.innerValue.toString() };
    }
    else if (this.innerValue instanceof File) return { title: this.innerValue.name, value: this.innerValue };
    else if (this.innerValue instanceof Array && this.Multiple == true) return { title: `تم تحميل عدد ${this.innerValue.length} ملف` };
    else if (this.innerValue instanceof Array && this.SingleFileInArray == true) {
      
      if (Array.isArray(this._files)) {
        
        const isFile = this._files.some(file => file instanceof File);
        
        if (isFile) {
          return { title: (this._files[0] as File)?.name, value: this._files[0] };
        }

      }

      return { title: `تم تحميل عدد ${this.innerValue.length} ملف` };
      

    }

  }
  
  /**
   * 
   */
  public get ProgressTitle(): { title?: string, progress: number } | any | null {

    /**
     * 
     */
    if (typeof this._progress === 'number') return { progress: this._progress }

    /**
     * 
     */
    if (typeof this._progress === 'string')  {

      switch(this._progress) {
        case HTTP_EVENT_TYPE.sending:
          return 'جاري التحميل';
        case HTTP_EVENT_TYPE.received:
          return 'تم استلام الملف و جاري المعالجة';
        case HTTP_EVENT_TYPE.compeleteUpload:
          return 'تمت المعالجة';
        case HTTP_EVENT_TYPE.response:
        default:
          return null;
      }

    }    

    /**
     * 
     */
    return null;

  }

  /**
   * Methods
   */

  /**
   * 
   */
  ngOnInit(): void {}

  /**
   * 
   * @param value 
   */
  public onChange = (value) => {};

  /**
   * 
   */
  public onTouched = () => {};   

  /**
   * 
   * @param value 
   */
  writeValue(value: string | string[] | File | File[] | null) {
    
    if (value?.toString()) {
      this._files = value;
      this.innerValue = value;

    }

  }

  /**
   * 
   * @param onChange 
   */
  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  /**
   * 
   * @param onTouched 
   */
  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  /**
   * 
   */
  public markAsTouched(): void {

    /**
     * 
     */
    if (this.disabled === true) return null;

    /**
     * 
     */
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }

  }

  /**
   * 
   * @param disabled 
   */
  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  /**
   * 
   */
  public reset(): void {

    /**
     * 
     */
    if (this.control != null) this.control.reset(null);

    /**
     * 
     */
    this._files = null;
    this.innerValue = null;


  }

  /**
   * 
   * @param event 
   */
  change(event: Event) {

    /**
     * 
     */
    this.innerValue = null;

    // ES6 Destruction
    const { files } = (event.target as HTMLInputElement);   

    /**
     * handler disabled input
     */
    if (this.disabled === true) return null;
    
    /**
     * handler empty files
     */
    if (files.length <= 0) return null;

    /**
     * handler limited
     */
    if (files.length > this.Limit) {

      /**
       * 
       */
      this.Errors = { limit: `الحد المسموح به فقط ${this.Limit} صورة` };

      /**
       * 
       */
      return null;
    }    

    /**
     * remove old error
     */
    if (this.Errors != null) this.Errors = null;     

    /**
     * 
     */
    this.markAsTouched();
 
    /**
     * init
     */
    let ValidFileType = true;
    const filesList: string[] & File[] = [];
 
    /**
     * 
     */
    for (let i = 0; i < files.length; i++) {

      /**
       * init
       */
      const file = files[i];

      /**
       * 
       */
      if (this.FileTypes?.length > 0) ValidFileType = this.FileTypes.some(type => file.type.includes(type));

      /**
       * 
       */
      if (ValidFileType !== true) break;

      /**
       * 
       */
      filesList.push(file);          
      
    } 
    
    /**
     * 
     */
    if (ValidFileType === false) {

      this.Errors = { fileTypes: `نوع الملف المطلوب هو ${this.FileTypes.join(', ')}` };

    }
    else {

      /**
       * 
       */
      if (this.Multiple === true) this._files = filesList;
      else this._files = this.SingleFileInArray === true ? filesList : filesList[0];

      /**
       * 
       */
      if (this.Server == true) this.uploadFilesToServer(this._files as any);
      else {

        /**
         * 
         */
        this.innerValue = this._files;

        /**
         * 
         */
        this.Change.emit(this._files);
  
        /**
         * 
         */
        this.onChange(this._files);

      }
      
    }
    
  } 
  
  
  /**
   * 
   * @param files 
   * @param key 
   */
  uploadFilesToServer(_fs: File | File[]) {

    /**
     * 
     */
    this.pending = true;
    this.setDisabledState(true);


    // init 
    let formData = new FormData();

    /**
     * handle single or multiple value
     */
    if (_fs instanceof File) formData.append(this.Name, _fs);
    else _fs.map(file => formData.append(this.Name, file)); 

    /**
     * 
     */
    this._api.uploadFilesForAd(formData)
    .pipe(
      map(res => {

      /**
       * 
       */
      if (typeof res === 'string') this._progress = res;
      else if (typeof res == 'object') {
        
        // ES6 Destruction
        const { event, progress, status } = res;

        /**
         * 
         */
        switch(status) {
          case HTTP_EVENT_TYPE.progress:
            this._progress = progress;
            break;
          case HTTP_EVENT_TYPE.compeleteUpload:            
          case HTTP_EVENT_TYPE.response:
            /**
             * 
             */
            this._progress = status;

            /**
             * 
             */
            if (event instanceof HttpResponse) return event.body[this.Name];
        
            break;
        }

      }

    }), last()
  )
    .subscribe(
      (res) =>  {

        /**
         * 
         */
        this.innerValue = res;

        /**
         * 
         */
        this.Change.emit(res);
  
        /**
         * 
         */
        this.onChange(res);

        /**
         * 
         */
        this.pending = false;
        this.setDisabledState(false);

      },
      (err: HttpErrorResponse) => {

        /**
         * 
         */
        this._progress = HTTP_EVENT_TYPE.errorResponse;

        // ES6 Destructuring
        const { error: { errors } } = err;
        const [ firstError ] = errors;

        /**
         * 
         */
        this.Errors = { uploadError: firstError?.msg }

        /**
         * 
         */
        this.pending = false;
        this.setDisabledState(false);

      }        
    )

  } 

}
